import { Text } from '@/components/ui/text';
import React from 'react';
import { View } from 'react-native';
import { SettingsItem, SettingsItemData, SettingsToggleItemData } from './settings-item';
import { SettingsToggleItem } from './settings-toggle-item';

export type SettingsSectionItem = SettingsItemData | SettingsToggleItemData;

interface SettingsSectionProps {
  title: string;
  items: SettingsSectionItem[];
}

function isToggleItem(item: SettingsSectionItem): item is SettingsToggleItemData {
  return 'value' in item && 'onToggle' in item;
}

export function SettingsSection({ title, items }: SettingsSectionProps) {
  return (
    <View className="mb-6">
      <Text
        className="text-sm mb-2 uppercase font-medium text-muted-foreground"
        accessibilityRole="header"
      >
        {title}
      </Text>
      <View className="rounded-xl p-4 bg-card">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          if (isToggleItem(item)) {
            return (
              <SettingsToggleItem key={index} item={item} isLast={isLast} />
            );
          }
          return <SettingsItem key={index} item={item} isLast={isLast} />;
        })}
      </View>
    </View>
  );
}
